import { NeutralTag, SuccessTag } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function StatusTag({ isActive }: { isActive: boolean }) {
  const { t } = useTranslation();

  if (isActive) {
    return (
      <SuccessTag testID="user-active-tag" type="subtle">
        {t("Active")}
      </SuccessTag>
    );
  }

  return (
    <NeutralTag testID="user-deactivated-tag" type="subtle">
      {t("Deactivated")}
    </NeutralTag>
  );
}
